import { render, staticRenderFns } from "./select-depart.vue?vue&type=template&id=1a6a0074"
import script from "./select-depart.vue?vue&type=script&lang=js"
export * from "./select-depart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports